import { render, staticRenderFns } from "./AddJustificationModal.vue?vue&type=template&id=a6f16cbe"
import script from "./AddJustificationModal.vue?vue&type=script&lang=js"
export * from "./AddJustificationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports